import(/* webpackMode: "eager" */ "/vercel/path0/src/app/masjids/[slug]/report/page.tsx");
